module.exports = __webpack_public_path__ + "static/media/smiley1.727c258f.png";